/**
 * Fallback copy when the live site API is unavailable.
 * Official public site: https://abaarsotechuniversity.org/
 */
export const UNIVERSITY = {
  shortName: "Abaarso Tech University",
  tagline: "Imagine. Inspire. Innovate.",
  mainWebsite: "https://abaarsotechuniversity.org/",
  featuredCampus: {
    name: "Berbera Campus",
    landline: "740388",
    mobile: "0634698887",
    locationLine: "Near Ministry of Education",
  },
  footer: {
    campus: "Hargeisa, Somaliland",
    addressLines: ["Near Ministry of Social Affairs", "Hargeisa, Somaliland"],
    email: "info@abaarsotechuniversity.org",
    phone: "+252 2 528629",
    phoneAlt: "Somtel 65 4858595",
  },
  about: {
    title: "About",
    paragraphs: [
      "Abaarso Tech is pioneering new ways of teaching and learning on our campus and around the world. We invent and leverage digital technologies and provide health professionals to society.",
      "Our aim is to inspire students to imagine and innovate and to become the future creative leadership class of the Somali peninsula and the world.",
    ],
  },
  vision: {
    title: "Vision",
    text: "Produce qualified and inspired students who excel in their subjects of study.",
  },
  mission: {
    title: "Mission",
    text: "We aim to provide the best possible education opportunities to our students in Somaliland and to create a center of educational excellence that matches other educational institutions in Africa and around the world.",
  },
  coreValues: {
    title: "Core values",
    items: [
      { name: "Integrity", description: "Honesty and accountability in learning, research, and daily conduct." },
      { name: "Excellence", description: "High standards in teaching, assessment, and continuous improvement." },
      { name: "Inclusion", description: "Respect for diverse backgrounds and equitable opportunity to succeed." },
      { name: "Innovation", description: "Creative problem-solving and responsible use of technology." },
      { name: "Service", description: "Commitment to community, stewardship, and the public good." },
    ],
  },
  programsOffered: {
    leftColumnTitle: "Degree programs",
    rightColumnTitle: "Degree & master programs",
    columns: [
      {
        schools: [
          {
            name: "School of Health Sciences",
            degrees: [
              "BSc in Medicine & Surgery",
              "BSc in Medical Laboratory Sciences",
              "BSc in Clinical Nursing",
              "BSc in Midwifery",
              "BSc in Pharmacy",
              "BSc in Nutrition & Food Sciences",
            ],
          },
          {
            name: "School of Business & Social Sciences",
            degrees: [
              "BSc in Human Resources Management",
              "BSc in Islamic Banking & Finance",
              "Bachelor of Arts in Accounting & Economics",
              "Bachelor in Social Work",
              "BA in Business Management & Economics",
              "Bachelor of Logistics & Procurements",
            ],
          },
        ],
      },
      {
        schools: [
          {
            name: "School of Computer Sciences",
            degrees: [
              "BSc in Software Engineering",
              "BSc in Information & Communication Technologies",
            ],
          },
          {
            name: "School of Law",
            degrees: ["Bachelor of Law (LLB)"],
          },
        ],
        masters: {
          title: "Master programs",
          degrees: [
            "Master of Business Administration",
            "Master of Islamic Banking & Finance",
            "Master of Public Health & Nutrition",
            "Master of Health Services Management",
            "Master of Logistics & Supply Chain Management",
            "Master of Project Planning & Management",
            "Master of Human Resources Management",
            "Master of Education",
            "Master of Law",
          ],
        },
      },
    ],
  },
};
